<template lang="pug">
  .table-responsive
    table#tbExistencias.table.is-striped.is-fullwidth
      thead
        tr
          th(align="center") #
          th(align="center") Descripción
          th(align="center") Existencia en Almacenes
      tbody
        tr(v-for="(data, index) in articulos" :key="index")
          td
            span.tag.is-black(@click="showChildrens(index, data)")
              | {{ index + 1 }}
          td(v-if="data.subcategoria")
            .control
              .tags.has-addons
                span.tag.is-black
                  i.fas.fa-tag
                  | &nbsp {{ data.categoria}}
                span.tag.is-warning {{ data.subcategoria}}
            .control
              .tags.has-addons
                span.tag.is-ligth
                  | Marca: {{ data.marca }}
                span.tag.is-light
                  | Modelo: {{ data.modelo}}
          td(v-else) 
            span.tag.is-black 
              i.fas.fa-tag
              | &nbsp {{ data.categoria }}
            .control
              .tags.has-addons
                span.tag.is-ligth
                  | Marca: {{ data.marca }}
                span.tag.is-light
                  | Modelo: {{ data.modelo}}
          td
            .field.is-grouped
              .control
                .tags.has-addons
                  span.tag(:class="checkAlmacen('EB04')") EB04 GIA
                  span.tag.is-link {{data.exist_EB04}}
              .control
                .tags.has-addons
                  span.tag(:class="checkAlmacen('TPA')") TPA GIA
                  span.tag.is-link {{data.exist_TPA}}
              .control
                .tags.has-addons
                  span.tag(:class="checkAlmacen('CORPORATIVO')") CORPO GIA
                  span.tag.is-link {{data.exist_CORP}}
              .control
                .tags.has-addons
                  span.tag(:class="checkAlmacen('EB04')") EB04 Cede
                  span.tag.is-info {{data.exist_EB04c}}
              .control
                .tags.has-addons
                  span.tag(:class="checkAlmacen('IRGE')") IRGE Cede
                  span.tag.is-info {{data.exist_IRGEc}}
              .control
                .tags.has-addons
                  span.tag(:class="checkAlmacen('IRGE')") IRGE Activos
                  span.tag.is-info {{data.exist_IRGEa}}
              .control
                .tags.has-addons
                  span.tag(:class="checkAlmacen('CORP')") CORPO Cede
                  span.tag.is-info {{data.exist_CORPc}}
              .control
                .tags.has-addons
                  span.tag(:class="checkAlmacen('TPA')") TPA Cede
                  span.tag.is-info {{data.exist_TPAc}}
</template>

<script>
  import { mapState } from 'vuex'
  export default {
    name: 'TbArticulos',
    props: {
      articulos: {
        type: Array,
        default: []
      },
    },
    data() {
      return {
        childrenSel: {}
      }
    },
    methods: {
      checkAlmacen(ubi) {
        let clase = ''
        if (this.userLogin.ubicacion === ubi ) {
          clase = 'is-black'
        } else {
          clase = 'is-ligth'
        }
        return clase
      },
      showChildrens (index, children) {
        console.log(children)
        this.childrenSel = children
        this.$emit('showChildrens', children)
      },
    },
    computed: {
      ...mapState(['userLogin'])
    }
  }
</script>

<style lang="scss" scoped>

</style>


// WEBPACK FOOTER //
// src/components/inventario_Componentes/TbArticulos.vue